import { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, DatePicker, Button, Table, message } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import moment from "moment";

import DataTotalDisplay from "../../component/data-total-display/data-total-display.component";

import { setMenu } from "../../redux/reducers/navigationSlice";
import { setUserAccount } from "../../redux/reducers/userAccountSlice";
import GuestAPI from "../../api/GuestAPI";

import "./guest-report.styles.css";

const initialFormValues = {
  cedula: "",
  fullName: "",
  phone: "",
  createdDate: "",
  dueDate: "",
  createdBy: "",
};

const tableColumns = [
  {
    title: "Cédula",
    dataIndex: "Cedula",
  },
  {
    title: "Nombre",
    dataIndex: "FullName",
  },
  { title: "Teléfono", dataIndex: "Phone" },
  {
    title: "Fecha Creado",
    dataIndex: "CreatedDate",
  },
  {
    title: "Fecha Vencimiento",
    dataIndex: "DueDate",
  },
  {
    title: "Creado Por",
    dataIndex: "CreatedBy",
  },
];

const GuestReportPage = () => {
  const dispatch = useDispatch();
  const [messageApi, messageContext] = message.useMessage();
  const token = useSelector((stage) => stage.userAccount.user.token);
  const [searchForm] = Form.useForm();

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [guestsListData, setGuestsListData] = useState({
    guests: [],
    totalCount: 0,
  });

  const loadInitialData = useCallback(async () => {
    messageApi.open({ type: "loading", content: "Cargando..." });

    try {
      const response = await GuestAPI.getGuestsList(token);

      if (!response.data.success) {
        messageApi.open({
          type: "error",
          content: response.data.message,
        });
        return;
      }

      setGuestsListData(response.data.data);
    } catch (ex) {
      console.error(ex.message);

      let message = "Servicio no disponible, intente más tarde. ";

      if (ex.code !== "ERR_NETWORK") {
        message = ex.response.data.message;

        if (ex.response.status === 401) dispatch(setUserAccount(null));
      }

      messageApi.open({ type: "error", content: message });
    } finally {
      messageApi.destroy();
    }
  }, [dispatch, messageApi, token]);

  const loadGuestsList = async (activePage = 1, activePageSize = 10) => {
    messageApi.open({ type: "loading", content: "Cargando..." });

    try {
      const createdDate = searchForm.getFieldValue("createdDate")
        ? moment(
            new Date(
              searchForm.getFieldValue("createdDate")
            ).toLocaleDateString(),
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")
        : "";
      const dueDate = searchForm.getFieldValue("dueDate")
        ? moment(
            new Date(searchForm.getFieldValue("dueDate")).toLocaleDateString(),
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")
        : "";
      const response = await GuestAPI.getGuestsList(token, {
        page: activePage,
        pageSize: activePageSize,
        ...searchForm.getFieldsValue(),
        createdDate,
        dueDate,
      });

      if (!response.data.success) {
        messageApi.open({
          type: "error",
          content: response.data.message,
        });
        return;
      }

      setCurrentPage(activePage);
      setGuestsListData(response.data.data);
    } catch (ex) {
      console.error(ex.message);
      let message = "Servicio no disponible, intente más tarde. ";

      if (ex.code !== "ERR_NETWORK") {
        message = ex.response.data.message;

        if (ex.response.status === 401) dispatch(setUserAccount(null));
      }

      messageApi.open({ type: "error", content: message });
    } finally {
      messageApi.destroy();
    }
  };

  useEffect(() => {
    dispatch(setMenu("guestReport"));
    loadInitialData();
  }, [dispatch, loadInitialData]);

  return (
    <div className="guest-report">
      <>{messageContext}</>
      <Form
        className="guests-search-form"
        initialValues={initialFormValues}
        form={searchForm}
        onFinish={() => loadGuestsList()}
        size="small"
        labelCol={{
          span: 10,
        }}
        wrapperCol={{
          span: 12,
        }}
      >
        <Form.Item label="Cédula" name="cedula">
          <Input />
        </Form.Item>
        <Form.Item label="Nombre" name="fullName">
          <Input />
        </Form.Item>
        <Form.Item label="Teléfono" name="phone">
          <Input />
        </Form.Item>
        <Form.Item label="Fecha creado" name="createdDate">
          <DatePicker format="DD/MM/YYYY" />
        </Form.Item>
        <Form.Item label="Fecha vencimiento" name="dueDate">
          <DatePicker format="DD/MM/YYYY" />
        </Form.Item>
        <Form.Item label="Creado por" name="createdBy">
          <Input />
        </Form.Item>
        <div className="buttons-container">
          <Button type="primary" htmlType="submit">
            <SearchOutlined />
            Buscar
          </Button>
          <Button
            onClick={() => {
              searchForm.resetFields();
              searchForm.submit();
            }}
          >
            <ClearOutlined />
            Limpiar
          </Button>
        </div>
      </Form>
      <DataTotalDisplay
        currentCount={guestsListData.guests.length}
        totalCount={guestsListData.totalCount}
      />
      <Table
        columns={tableColumns}
        dataSource={guestsListData.guests}
        size="small"
        pagination={{
          current: currentPage,
          pageSize: currentPageSize,
          total: guestsListData.totalCount,
        }}
        onChange={(e) => {
          loadGuestsList(e.current, e.pageSize);
          setCurrentPage(e.current);
          setCurrentPageSize(e.pageSize);
        }}
        scroll={{ y: "360px" }}
        style={{ height: "360px" }}
      ></Table>
    </div>
  );
};

export default GuestReportPage;
